import { useState } from "react";
// Paths já projetados no build (scripts/generate-brazil-map-paths.mjs): sem
// d3-geo nem GeoJSON no bundle e sem cálculo na thread principal.
import {
  BR_MAP_VIEW_H,
  BR_MAP_VIEW_W,
  BR_STATE_PATHS,
} from "../utils/brStatesPaths";

const UF_NAMES: Record<string, string> = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins",
};

// ⬇️ Estados onde a Fidexa atua (destacados em laranja).
// Edite esta lista conforme a cobertura real. (placeholder até confirmação)
const ACTIVE_UFS = new Set([
  "AP",
  "PA",
  "MA",
  "MT",
  "MS",
  "GO",
  "TO",
  "MG",
  "BA",
  "ES",
  "SP",
  "PR",
  "RS",
  "AL",
  "SE",
]);

const ACTIVE_FILL = "#FFA46B"; // primary-v2-300 — laranja do hover virou padrão
const ACTIVE_HOVER = "#F77234"; // primary-v2-400
const INACTIVE_FILL = "#d3d7d4"; // cinza-claro do mockup
const INACTIVE_HOVER = "#c2c7c4";
const STROKE = "#9ca3af";

const VIEW_W = BR_MAP_VIEW_W;
const VIEW_H = BR_MAP_VIEW_H;

type Tip = { uf: string; x: number; y: number };

export function BrazilMap() {
  const [tip, setTip] = useState<Tip | null>(null);
  const [hovered, setHovered] = useState<string | null>(null);

  const paths = BR_STATE_PATHS;

  return (
    <div className="relative w-full">
      <svg
        viewBox={`0 0 ${VIEW_W} ${VIEW_H}`}
        className="h-auto w-full"
        role="img"
        aria-label="Mapa do Brasil — estados onde a Fidexa atua"
      >
        {paths.map(({ uf, d }) => {
          const active = ACTIVE_UFS.has(uf);
          const isHover = hovered === uf;
          const fill = active
            ? isHover
              ? ACTIVE_HOVER
              : ACTIVE_FILL
            : isHover
              ? INACTIVE_HOVER
              : INACTIVE_FILL;
          return (
            <path
              key={uf}
              d={d}
              fill={fill}
              stroke={STROKE}
              strokeWidth={0.6}
              className="cursor-pointer transition-colors"
              onMouseEnter={e => {
                setHovered(uf);
                setTip({
                  uf,
                  x: e.nativeEvent.offsetX,
                  y: e.nativeEvent.offsetY,
                });
              }}
              onMouseMove={e =>
                setTip(prev =>
                  prev
                    ? { ...prev, x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY }
                    : prev
                )
              }
              onMouseLeave={() => {
                setHovered(null);
                setTip(null);
              }}
              onClick={() => {
                // Clique reservado — sem ação por enquanto.
              }}
            />
          );
        })}
      </svg>

      {tip && (
        <div
          className="pointer-events-none absolute z-10 -translate-x-1/2 -translate-y-full rounded-md border border-gray-200 bg-white px-2 py-1 text-xs font-medium text-gray-900 shadow-md"
          style={{ left: tip.x, top: tip.y - 6 }}
        >
          {UF_NAMES[tip.uf] ?? tip.uf}
        </div>
      )}
    </div>
  );
}
